import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { translationHookOptions } from "../../app/localization/localization";
import { Button } from "reactstrap";
import ProtectedDownload from "./ProtectedDownload";

interface IParams {
  title: string;
  link?: string;
  className?: string;
  archiveId?: number;
  contentId?: number;
  handleActionDownload : (filename: string, href: string) => void;
}

const TreeArchiveElement: React.FC<IParams> = ({ title, link, className, archiveId, contentId ,handleActionDownload}) => {
  const [t] = useTranslation(["translation"], translationHookOptions);

  // IMPORTANTE pPER  il bottone DOWNLOAD a destra è stato gestito nel browsePage.scss 
/* 
.treeArchiveElement {
  overflow-wrap: break-word !important;
  white-space: pre-wrap !important;
  max-width: calc(95% - 70px) !important;
}
/ serve per rendere visibile il bottone di eliminazione di un elemento dell'albero
.rc-tree-treenode {
  display: flex !important;
}
.btndownloadArchiveTreeElement {
  position: absolute;
  right: 0; 
  top: 50%; 
  transform: translateY(-50%);
}

*/

  const formatTitleDiv = (title: string) => {
    return (
      <div className={classNames(`treeArchiveElement ${className}`, title ? "" : "font-italic")}>
        {title ? title : t("empty_title_node")}
      </div>
    );
  };
  
  

return (
  <>
    { contentId ?  (
       <>
<div className="odgElement">
          {link ? <Link to={link}>{formatTitleDiv(title)}</Link> : formatTitleDiv(title)}
           </div>
         <ProtectedDownload
            handleActionDownload = {handleActionDownload}
            hasLoaderModal={true}
            url={`/content/archive/${archiveId}/download/${contentId}`}
            children={
              <Button
              className="btndownloadArchiveTreeElement specificCss"
                id={`btndownload_${contentId}`}
                color="link"
                onMouseEnter={() =>{}}
                onMouseLeave={() =>  {}}
             
              >
                <i className="fas fa-download fa-lg text-default iconBoxList"></i>
              </Button>
            }
          ></ProtectedDownload>
          </>
      
    ) : (
      <div className="odgElement">{formatTitleDiv(title)}</div>
    )}
  </>
);
};

export default observer(TreeArchiveElement);
